import React from "react";
import Navbar from "../../Components/Navbar/Navbar";

export default function About() {

    return (
        <div className="about-container" id="about-container">
            <Navbar/>
            <h1>
                This is About Page
            </h1>
        </div>
    )
}

